import reportTypes from "../components/Reports/reportTypes";
import axios from "./axios";

const getSortKey = (id) => {
  // see https://git.customd.com/afes/afes-api/-/blob/main/app/Http/Resources/SupporterResource.php#L18-34
  switch (id) {
    // case "amount":
    //   return "amount";
    case "id":
      return "filemaker_contact_id";
    // case "frequency":
    //   return "frequency";
    // case "program_id":
    //   return "program_id";
    case "date_next_debit":
      return "next_debit_at";
    case "method":
      return "payment_type_payment_type";
    case "date_end":
      return "end_at";
    case "date_created":
      return "created_at";
    case "date_modified":
      return "updated_at";
    case "fullname":
      return "contact_name";
    case "lastname":
      return "contact_name_last";
    // case "status":
    //   return "status";
    case "date_last_deposit":
      return "latest_banked_date_banked";
    case "amount_last_deposit":
      return "latest_banked_amount_debit";
    default:
      return id; // Default case when the key is not found
  }
};

const prepareSortParams = (args) => {
  return args
    .map((arg) => `${getSortKey(arg.id)} ${arg.desc ? "desc" : "asc"}`)
    .join();
};

const queryStringify = (params) =>
  Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");

class SupportersAPI {
  // eslint-disable-next-line class-methods-use-this
  getOne(contactID) {
    return axios.get(`api/supporters/${contactID}`);
  }

  // eslint-disable-next-line class-methods-use-this
  getChanges(contactID) {
    // eslint-disable-next-line no-undef
    return {}; // fetchGet(`${Site.api_url}supporter/changes?id=${contactID}`);
  }

  // eslint-disable-next-line class-methods-use-this
  save(data) {
    const newData = data;
    delete newData.address;
    delete newData.display;
    // eslint-disable-next-line no-undef
    return {}; // fetchPost(`${Site.api_url}supporter`, newData);
  }

  // eslint-disable-next-line camelcase, class-methods-use-this
  getMany(signal, reportType, program_id, sortBy, searchQuery, page) {
    const params = { program_id };

    if (sortBy?.length > 0) {
      params.sort = prepareSortParams(sortBy);
    }

    if (page) {
      params.page = page;
    }

    if (searchQuery) {
      params.fullname = searchQuery;
    }

    let url;

    switch (reportType) {
      case reportTypes.changes:
        url = "changes";
        break;
      case reportTypes.received:
        url = "history";
        break;
      default:
        url = "current";
        params.exclude_once_off = 1;
        break;
    }

    return axios.get(`api/support/${url}?${queryStringify(params)}`, {
      signal,
    });
  }
}

const Supporters = new SupportersAPI();

export default Supporters;
